import { createAction } from '@poa/state';


export const fetchWallet = createAction('wallet/fetchWallet', () => ({}));
export const fetchWalletSuccess = createAction('wallet/fetchWalletSuccess',(data) => ({data}));
export const fetchWalletFailed = createAction('wallet/fetchWalletFailed', () => ({}));
